import { render } from "./SquarePlusIcon.vue?vue&type=template&id=f4b8a138"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__